module.exports = __webpack_public_path__ + "img/C04MountedArcher2_ua.bff180a1.webp";